import { map, mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import { placesService } from "../../../common/services";
import * as actionTypes from "./actionTypes";
import * as placeActions from "./actions";

export function fetchPlace(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_PLACE),
    mergeMap(({ payload }) => {
      return placesService.getPlaceById(payload).pipe(
        map((res) =>
          placeActions.fetchPlaceSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
export function fetchPlaces(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_PLACES),
    mergeMap(({ payload }) => {
      return placesService.getPlaces(payload).pipe(
        map((res) =>
          placeActions.fetchPlacesSuccess([res.responceObject.records])
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
export function savePlace(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_PLACE),
    mergeMap(({ payload }) => {
      return placesService.addPlace(payload).pipe(
        map((res) => placeActions.savePlaceSuccess(res.responceObject.records)),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
export function updatePlace(action$) {
  return action$.pipe(
    ofType(actionTypes.UPDATE_PLACE),
    mergeMap(({ payload }) => {
      return placesService.updatePlace(payload).pipe(
        map((res) =>
          placeActions.updatePlaceSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}

export function deletePlace(action$) {
  return action$.pipe(
    ofType(actionTypes.DELETE_PLACE),
    mergeMap(({ payload }) => {
      return placesService.deletePlace(payload).pipe(
        map((res) => placeActions.deletePlaceSuccess(payload)),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
